var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSectionToggleButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.35556V10.6444L10.5878 8L6.75 5.35556ZM2.21622 15C1.88176 15 1.59544 14.8858 1.35726 14.6573C1.11909 14.4288 1 14.1542 1 13.8333L1 2.16667C1 1.84583 1.11909 1.57118 1.35726 1.34271C1.59544 1.11424 1.88176 1 2.21622 1L19.7838 1C20.1182 1 20.4046 1.11424 20.6427 1.34271C20.8809 1.57118 21 1.84583 21 2.16667V13.8333C21 14.1542 20.8809 14.4288 20.6427 14.6573C20.4046 14.8858 20.1182 15 19.7838 15L2.21622 15ZM16.8041 13.8333H19.7838V2.16667L16.8041 2.16667V13.8333ZM15.5878 13.8333L15.5878 2.16667L2.21622 2.16667L2.21622 13.8333L15.5878 13.8333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSectionToggleButton);
export default __webpack_public_path__ + "static/media/left-section-toggle-button.f2aa23c8fc3f11ae6a3f871424c6d88e.svg";
export { ForwardRef as ReactComponent };